import { uniqBy } from "lodash";
import { FormError } from "types/topicflow";

import { ProgramFormTab } from "./types";

const ProgramFormErrorBanner = ({
  errors,
  fieldToTab,
  onJumpToError,
}: {
  errors: FormError[];
  fieldToTab: Record<string, ProgramFormTab>;
  onJumpToError: (error: FormError) => void;
}) => {
  if (errors.length === 0) {
    return null;
  }
  const dedupedErrors = uniqBy(
    errors,
    (error) => `${error.field}::${error.message}`,
  );
  return (
    <div className="mb-6 rounded-md border border-red-200 bg-red-50 p-4">
      <div className="text-sm font-medium text-red-800">
        {dedupedErrors.length === 1
          ? "Please complete this before saving:"
          : `Please complete ${dedupedErrors.length} fields before saving:`}
      </div>
      <ul className="mt-2 list-disc pl-5 text-sm text-red-700 space-y-0.5">
        {dedupedErrors.map((error, index) => {
          const canJump = fieldToTab[error.field] !== undefined;
          return (
            <li key={`${error.field}-${index}`}>
              {canJump ? (
                <button
                  type="button"
                  className="text-left underline hover:text-red-900"
                  onClick={() => onJumpToError(error)}
                >
                  {error.message}
                </button>
              ) : (
                <span>{error.message}</span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ProgramFormErrorBanner;
